const FileExcel = ({ size }: { size: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.75 14.5H14.25C14.3875 14.5 14.5 14.3875 14.5 14.25V4.5H12.25C11.8365 4.5 11.5 4.1635 11.5 3.75V1.5H4.75C4.6125 1.5 4.5 1.6125 4.5 1.75V14.25C4.5 14.3875 4.6125 14.5 4.75 14.5Z"
      fill="white"
    />
    <path
      d="M14.1465 4.00002L12 1.85352V3.75002C12 3.88752 12.1125 4.00002 12.25 4.00002H14.1465Z"
      fill="white"
    />
    <path
      opacity="0.64"
      d="M14.78 3.927L12.073 1.2195C11.9321 1.07945 11.7417 1.00058 11.543 1H4.75C4.3365 1 4 1.3365 4 1.75V14.25C4 14.6635 4.3365 15 4.75 15H14.25C14.6635 15 15 14.6635 15 14.25V4.457C15 4.257 14.922 4.0685 14.78 3.927ZM12 1.8535L14.1465 4H12.25C12.1838 3.99987 12.1202 3.97349 12.0733 3.92663C12.0265 3.87978 12.0002 3.81627 12 3.75V1.8535ZM14.25 14.5H4.75C4.68373 14.4998 4.62022 14.4735 4.57337 14.4267C4.52651 14.3798 4.50013 14.3162 4.5 14.25V1.75C4.5 1.6125 4.6125 1.5 4.75 1.5H11.5V3.75C11.5 4.1635 11.8365 4.5 12.25 4.5H14.5V14.25C14.5 14.3875 14.3875 14.5 14.25 14.5Z"
      fill="#605E5C"
    />
    <path
      d="M12.5 11.5H11.5C11.3674 11.5 11.2402 11.4473 11.1465 11.3535C11.0527 11.2598 11 11.1326 11 11C11 10.8674 11.0527 10.7402 11.1465 10.6465C11.2402 10.5527 11.3674 10.5 11.5 10.5H12.5C12.6326 10.5 12.7598 10.5527 12.8535 10.6465C12.9473 10.7402 13 10.8674 13 11C13 11.1326 12.9473 11.2598 12.8535 11.3535C12.7598 11.4473 12.6326 11.5 12.5 11.5Z"
      fill="#134A2C"
    />
    <path
      d="M10 11.5H9C8.8674 11.5 8.7402 11.4473 8.64645 11.3535C8.5527 11.2598 8.5 11.1326 8.5 11C8.5 10.8674 8.5527 10.7402 8.64645 10.6465C8.7402 10.5527 8.8674 10.5 9 10.5H10C10.1326 10.5 10.2598 10.5527 10.3535 10.6465C10.4473 10.7402 10.5 10.8674 10.5 11C10.5 11.1326 10.4473 11.2598 10.3535 11.3535C10.2598 11.4473 10.1326 11.5 10 11.5Z"
      fill="#185C37"
    />
    <path
      d="M12.5 9.5H11.5C11.3674 9.5 11.2402 9.4473 11.1465 9.35355C11.0527 9.2598 11 9.1326 11 9C11 8.8674 11.0527 8.7402 11.1465 8.64645C11.2402 8.5527 11.3674 8.5 11.5 8.5H12.5C12.6326 8.5 12.7598 8.5527 12.8535 8.64645C12.9473 8.7402 13 8.8674 13 9C13 9.1326 12.9473 9.2598 12.8535 9.35355C12.7598 9.4473 12.6326 9.5 12.5 9.5Z"
      fill="#21A366"
    />
    <path
      d="M10 9.5H9C8.8674 9.5 8.7402 9.4473 8.64645 9.35355C8.5527 9.2598 8.5 9.1326 8.5 9C8.5 8.8674 8.5527 8.7402 8.64645 8.64645C8.7402 8.5527 8.8674 8.5 9 8.5H10C10.1326 8.5 10.2598 8.5527 10.3535 8.64645C10.4473 8.7402 10.5 8.8674 10.5 9C10.5 9.1326 10.4473 9.2598 10.3535 9.35355C10.2598 9.4473 10.1326 9.5 10 9.5Z"
      fill="#107C41"
    />
    <path
      d="M12.5 7.5H11.5C11.3674 7.5 11.2402 7.4473 11.1465 7.35355C11.0527 7.2598 11 7.1326 11 7C11 6.8674 11.0527 6.7402 11.1465 6.64645C11.2402 6.5527 11.3674 6.5 11.5 6.5H12.5C12.6326 6.5 12.7598 6.5527 12.8535 6.64645C12.9473 6.7402 13 6.8674 13 7C13 7.1326 12.9473 7.2598 12.8535 7.35355C12.7598 7.4473 12.6326 7.5 12.5 7.5Z"
      fill="#33C481"
    />
    <path
      d="M10 7.5H9C8.8674 7.5 8.7402 7.4473 8.64645 7.35355C8.5527 7.2598 8.5 7.1326 8.5 7C8.5 6.8674 8.5527 6.7402 8.64645 6.64645C8.7402 6.5527 8.8674 6.5 9 6.5H10C10.1326 6.5 10.2598 6.5527 10.3535 6.64645C10.4473 6.7402 10.5 6.8674 10.5 7C10.5 7.1326 10.4473 7.2598 10.3535 7.35355C10.2598 7.4473 10.1326 7.5 10 7.5Z"
      fill="#21A366"
    />
    <path
      d="M1.75 12.5H7.25C7.4489 12.5 7.6397 12.421 7.78035 12.2803C7.921 12.1397 8 11.9489 8 11.75V6.25C8 6.0511 7.921 5.8603 7.78035 5.71965C7.6397 5.579 7.4489 5.5 7.25 5.5H1.75C1.55109 5.5 1.36032 5.579 1.21967 5.71965C1.07902 5.8603 1 6.0511 1 6.25V11.75C1 11.9489 1.07902 12.1397 1.21967 12.2803C1.36032 12.421 1.55109 12.5 1.75 12.5Z"
      fill="#107C41"
    />
    <path
      d="M3 11L4.087 8.995L3.091 7H3.892L4.4355 8.2745C4.4855 8.3955 4.52 8.486 4.5385 8.5455H4.546C4.5815 8.4485 4.619 8.3545 4.658 8.2635L5.239 7H5.974L4.953 8.9835L6 11H5.2175L4.59 9.6C4.56012 9.53955 4.53504 9.47685 4.515 9.4125H4.506C4.48804 9.4753 4.46374 9.5361 4.4335 9.594L3.787 11H3Z"
      fill="#F9F7F7"
    />
  </svg>
);

export default FileExcel;
